import React from 'react';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import {ThemeProvider} from '@material-ui/core/styles'
import {generarTema} from './componentes/layout/Tema'
import AuthProvider  from './componentes/context/AuthContext';
import GeneralesProvider from './componentes/context/GeneralesContext';
import ClienteProvider from './componentes/context/ClienteContext';
import Contenedor from './componentes/layout/Contenedor'
import Login from './componentes/auth/Login'
import { ToastContainer } from 'react-toastify';
import PerfilInicio from './componentes/perfiles/PerfilInicio';
import Usuario from './componentes/usuario/UsuarioInicio'
import PrincipalInicio from './componentes/principal/Principal'
import DistritoInicio from './componentes/regional/RegionalInicio';
import SugerenciaPublico from './componentes/SugerenciaPub';
import 'react-toastify/dist/ReactToastify.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import Apoyo from './componentes/Apoyo/Apoyo'
import PerfilExterno from './componentes/perfilExt';
import Recorrido from "./componentes/Recorrido";
import MapaSecciones from './componentes/mapa'
import RegistroPrevio from './componentes/registro-previo';
function App() {
  const [colorTema,setColorTema] = React.useState(false);
  React.useEffect(()=>{
    const auxColor= localStorage.getItem('ColorTheme');
    if ( auxColor===undefined || auxColor===null) 
    {
      localStorage.setItem('ColorTheme',colorTema);
      console.log("sin el tema");
    }
    else
    {  console.log("cargando el tema");
      //console.log(JSON.parse(auxColor));
      setColorTema(JSON.parse(auxColor))    
    }
  },[])

  return (
  <React.Fragment >
    <AuthProvider>
      <GeneralesProvider>
        <ClienteProvider>
        <Router>
          <ThemeProvider theme={generarTema(colorTema)}>
            <Contenedor colorTema={colorTema} setColorTema={setColorTema}>              
              <Switch>
                <Route exact path="/" component={Login}  />          
                <Route exact path="/lista-perfil" component={PerfilInicio}  />
                <Route exact path="/perfil-externo" component={PerfilExterno}  />   
                <Route exact path="/lista-Usuario" component={Usuario}  />   
                <Route exact path="/inicio" component={PrincipalInicio}  />   
                <Route exact path="/distrito" component={DistritoInicio}  />                 
                <Route exact path="/sugerencias" component={SugerenciaPublico}  />   
                <Route exact path="/apoyo" component={Apoyo}  />                   
                <Route exact path="/recorrido" component={Recorrido}  />
                <Route exact path="/registro-previo" component={RegistroPrevio}  />
                <Route exact path="/agrega-mapa-secc" component={MapaSecciones}  />
                <Route path="*" component={  Login } />
              </Switch>              
            </Contenedor>
          </ThemeProvider>
          <ToastContainer autoClose={5000} closeOnClick/>
        </Router>
        </ClienteProvider>
      </GeneralesProvider>
    </AuthProvider>
  </React.Fragment>
  );
}

export default App;